<template>
  <div>
    <v-dialog v-model="showInstallPrompt" max-width="400px">
      <v-card>
        <v-card-title class="headline">Install App</v-card-title>
        <v-card-text>
          <p>Install this MinSU Locator System on your device for quick and easy access.</p>
          <p v-if="isIOS" class="text-body-2 mt-2">
            On iOS: Tap the share icon <v-icon small>mdi-share-variant</v-icon> and then "Add to Home Screen"
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closePrompt">Not now</v-btn>
          <v-btn 
            color="primary" 
            @click="installApp"
            v-if="!isIOS"
          >
            Install
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'InstallPrompt',
  data() {
    return {
      deferredPrompt: null,
      showInstallPrompt: false,
      isIOS: false
    }
  },
  mounted() {
    // Check if it's iOS
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      // App is already installed, don't show prompt
      return;
    }
    
    // Listen for the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later
      this.deferredPrompt = e;
      // Show the install prompt
      this.showInstallPrompt = true;
    });
    
    // For iOS devices, we'll show a custom prompt
    if (this.isIOS) {
      // Only show if not in standalone mode and not shown before
      const hasShownPrompt = localStorage.getItem('pwaPromptShown');
      if (!hasShownPrompt) {
        this.showInstallPrompt = true;
        // Mark as shown in localStorage
        localStorage.setItem('pwaPromptShown', 'true');
      }
    }
  },
  methods: {
    async installApp() {
      if (!this.deferredPrompt) {
        this.closePrompt();
        return;
      }
      
      // Show the install prompt
      this.deferredPrompt.prompt();
      
      // Wait for the user to respond to the prompt
      const { outcome } = await this.deferredPrompt.userChoice;
      console.log(`User response to the install prompt: ${outcome}`);
      
      // We no longer need the prompt. Clear it up
      this.deferredPrompt = null;
      
      // Hide our UI
      this.closePrompt();
    },
    closePrompt() {
      this.showInstallPrompt = false;
    }
  }
}
</script>